import { KnaufPlaster } from './knauf-plaster.enum';
export class Calculator {
    private static isMineralPlaster(plaster: KnaufPlaster): Boolean {
        return (plaster == KnaufPlaster.KnaufRP240Kornik || plaster == KnaufPlaster.KnaufSP260Baranek);
    }
    static calculatePlasterBuckets(plaster: KnaufPlaster, metry: number, granulat: number): number {
        if (granulat == 0)
            return 0;
        let wydajnosc: number = 0.0;
        switch (granulat) {
            case 1: wydajnosc = 14; break;
            case 2: wydajnosc = this.isMineralPlaster(plaster) ? 12.0 : 10.0; break;
            case 3: wydajnosc = this.isMineralPlaster(plaster) ? 10.0 : 8.0; break;
        }
        return Math.ceil(metry / wydajnosc);
    }
    static calculateMosaicBuckets(meters: number, granulat: number): number {
        if (granulat == 0)
            return 0;
        let wydajnosc: number = 0.0;
        if (granulat == 1) {
            wydajnosc = 7.5;
        } else {
            wydajnosc = 5.5;
        }
        return Math.ceil(meters/wydajnosc);
    }
}
